// React
import { createContext } from "react"

// Types
import type { SellingList } from "../types"

export const SellingContext = createContext<SellingList[]>([])